import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { axios_tenant } from "../../axios";

const TenantAdminRoute = ({ element }) => {
  let sessionId = sessionStorage.getItem("sessionId");

  if (!sessionId) {
    sessionId = uuidv4();
    sessionStorage.setItem("sessionId", sessionId);
  }

  const location = useLocation();
  localStorage.setItem("latestPath", location.pathname + location.search);

  const isAuthenticated = !!localStorage.getItem("TREXO_TENANT_AUTH_TOKEN");
  const isKotRoute = location.pathname.startsWith("/kot");

  const [loading, setLoading] = useState(isKotRoute);
  const [hasKotAccess, setHasKotAccess] = useState(false);

  const [prevPathname, setPrevPathname] = useState(location.pathname);

  if (location.pathname !== prevPathname) {
    const wasKot = prevPathname.startsWith("/kot");
    setPrevPathname(location.pathname);

    if (isKotRoute && !wasKot) {
      setLoading(true);
      setHasKotAccess(false);
    }
  }

  useEffect(() => {
    if (!isAuthenticated || !isKotRoute) {
      setLoading(false);
      return;
    }

    const fetchKotAccess = async () => {
      setLoading(true);
      setHasKotAccess(false);
      try {
        const { data } = await axios_tenant.get("/kot/me/access");
        setHasKotAccess(data.hasKotAccess);
      } catch (error) {
        setHasKotAccess(false);
      } finally {
        setLoading(false);
      }
    };

    fetchKotAccess();
  }, [isAuthenticated, isKotRoute]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isKotRoute) {
    if (loading) {
      return null;
    }

    if (!hasKotAccess) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return element;
};

export default TenantAdminRoute;